export default __webpack_public_path__ + "static/font-bfaf1b8c9609cf49e8cbd10c151cbbf1.woff2";